<script setup lang="ts">
import ConfirmDialog from 'primevue/confirmdialog'
import GbButton from '@/components/GbButton.vue'
import { SAVE_IOD_CONFIRMATION_GROUP } from './composables/useSaveIODConfirmation'
import { vFocusOnMount } from '@/util/focus_on_mount'

const HEADER_ID = 'save-iod-confirmation-header'
</script>

<template>
  <ConfirmDialog :group="SAVE_IOD_CONFIRMATION_GROUP" :aria-labelledby="HEADER_ID" class="w-auto md:w-[38rem]">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col rounded-md bg-surface-50" data-testid="save-iod-confirmation">
        <div class="flex items-center justify-between border-b border-gray-300 py-3 px-5">
          <div class="flex items-center gap-2">
            <span class="material-icons-round" aria-hidden="true">info_outline</span>
            <h2 :id="HEADER_ID" class="text-xl font-medium m-0">Proceed with Save to Library?</h2>
          </div>
          <GbButton
            size="small"
            rounded
            :iconOnly="true"
            aria-label="Close"
            gbTheme="grayTertiary"
            @click="rejectCallback"
          >
            <span class="material-icons-round">close</span>
          </GbButton>
        </div>
        <p class="py-5 px-6 text-gray-700">
          After saving this statement, you will still be able to make manual edits, but you will
          <strong>not</strong> be able to make updates to the <strong>Disability</strong>,
          <strong>Subjects</strong>, or <strong>Impacted Areas</strong>. Do you still want to save this statement?
        </p>
        <div class="flex items-center justify-end gap-2 border-t border-gray-300 py-4 px-5">
          <GbButton label="Cancel" gbTheme="grayOutlineSecondary" @click="rejectCallback" />
          <GbButton v-focus-on-mount :label="message.acceptLabel" gbTheme="greenPrimary" @click="acceptCallback" />
        </div>
      </div>
    </template>
  </ConfirmDialog>
</template>
